import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { notificationType } from './shared_proptypes';
import BulkOperationNotification from './notification_templates/BulkOperationNotification';
import CustomRegionUploadNotification from './notification_templates/CustomRegionUploadNotification';
import TransactionCorrectionUploadNotification from './notification_templates/TransactionCorrectionUploadNotification';
import DiscoveredPhoneNumberNotification from './notification_templates/DiscoveredPhoneNumberNotification';
import DestinationPromotionErrorsNotification from './notification_templates/DestinationPromotionErrorsNotification';
import CampaignApplicationNotification from "./notification_templates/CampaignApplicationNotification";
import CommentNotification from "./notification_templates/CommentNotification";

import moment from 'moment';

function HideIcon(props) {
  return (
    <span className="notification-dropdown__item-hide">
      <i className="material-icons" data-action="hide-icon" onClick={props.onClick}>close</i>
    </span>
  );
}

HideIcon.propTypes = {
  onClick: PropTypes.func
};

const notificationTemplates = {
  'bulk_operation': BulkOperationNotification,
  'transaction_correction_upload': TransactionCorrectionUploadNotification,
  'custom_region_upload': CustomRegionUploadNotification,
  'discovered_customer_phone_number': DiscoveredPhoneNumberNotification,
  'destination_promotion_error': DestinationPromotionErrorsNotification,
  'affiliate_campaign_application': CampaignApplicationNotification,
  'comment': CommentNotification
};

function DefaultTemplate(props) {
  return (
    <div className="notification-dropdown__item-message" data-attribute="item-message">
      {props.notification.message}
    </div>
  );
}

DefaultTemplate.propTypes = {
  notification: notificationType().isRequired
};

function notificationTemplate(notification) {
  const template = notificationTemplates[notification.type];
  return template || DefaultTemplate;
}

class MenuItem extends Component {
  static propTypes = {
    onHideItem:   PropTypes.func.isRequired,
    onClick:      PropTypes.func.isRequired,
    notification: notificationType().isRequired
  };

  render() {
    const { notification, onClick, onHideItem } = this.props;
    const itemUnreadStyling = notification.unread ? " notification-dropdown__item--unread" : "";
    const link = notification.linkButtonLabel ? undefined : notification.link;
    return (
      <a
        href={link}
        className={`notification-dropdown__item ${itemUnreadStyling}`}
        data-mount="menu-item"
        onClick={() => onClick(notification)}
      >
        <span className="notification-dropdown__item-content">
          {React.createElement(notificationTemplate(notification), { notification })}
          <div className="notification-dropdown__item-timestamp" data-attribute="item-timestamp">
            {moment(notification.timeStamp).fromNow()}
          </div>
        </span>
        <HideIcon onClick={(e) => onHideItem(notification, e)} />
      </a>
    );
  }
}

export default MenuItem;
